import { View } from 'react-native'
import { styles } from 'scenes/home/more/index/styles/styles'
import IconBackground, { IconBackgroundSizes } from 'components/atoms/IconBackground'
import { ThemedShared } from 'styles/themed'
import React from 'react'
import { colorList } from 'utils/colors'


const IconView = ({ icon, iconSize = IconBackgroundSizes.M, children  }) => {
	
	return (
		<IconBackground
			colourfull
			iconSize={ iconSize }
			linearGradientColours={ [ colorList.WHITE.primary, colorList.WHITE.dark ] }
			containerStyle={ ThemedShared.borderRadius }
			relative={ true }
			opacity={ 0.6 }>
			
			{ children ?? (
				<View style={ styles.buttonIconIconContainer }>
					{ icon }
				</View>
			)}
		</IconBackground>
	);
}

export default IconView
